import React from 'react'
import {
  IconPearDeck,
  IconAssignPearPractice,
  IconPearAssessmentTest,
} from '@edulastic/icons'
import {
  StyledAITestCreationOption,
  StyledAITestCreationOptionBetaTag,
  StyledAITestCreationOptionContainer,
  StyledAITestCreationOptionDescription,
  StyledAITestCreationOptionIconContainer,
  StyledAITestCreationOptionTitle,
  StyledAITestCreationOptionWrapper,
  StyledILPIconsContainer,
  StyledILPIconsText,
  StyledILPPackageContainer,
} from './styled'
import { AI_CREATION_OPTIONS } from './ducks/constants'

const AITestCreationOption = ({
  dataCy,
  option,
  optionIcon,
  title,
  description,
  packageIconsText,
  showBetaTag,
  handleOptionSelect,
}) => {
  return (
    <StyledAITestCreationOptionWrapper
      onClick={() => handleOptionSelect(option)}
    >
      <StyledAITestCreationOptionContainer data-cy={dataCy}>
        <StyledAITestCreationOptionIconContainer className="test-creation-option-icon-container">
          {optionIcon}
        </StyledAITestCreationOptionIconContainer>
        <StyledAITestCreationOption>
          <StyledAITestCreationOptionTitle>
            {title}{' '}
            {showBetaTag && (
              <StyledAITestCreationOptionBetaTag className="test-creation-option-beta-tag">
                BETA
              </StyledAITestCreationOptionBetaTag>
            )}
          </StyledAITestCreationOptionTitle>
          <StyledAITestCreationOptionDescription>
            {description}
          </StyledAITestCreationOptionDescription>
        </StyledAITestCreationOption>
        <StyledILPPackageContainer>
          <StyledILPIconsContainer>
            {option === AI_CREATION_OPTIONS.PEAR_ASSESSMENT_AI ? (
              <IconPearAssessmentTest />
            ) : (
              <>
                <IconPearDeck />
                <IconAssignPearPractice />
                <IconPearAssessmentTest />
              </>
            )}
          </StyledILPIconsContainer>
          {!!packageIconsText?.length && (
            <StyledILPIconsText>{packageIconsText}</StyledILPIconsText>
          )}
        </StyledILPPackageContainer>
      </StyledAITestCreationOptionContainer>
    </StyledAITestCreationOptionWrapper>
  )
}

export default AITestCreationOption
